/**
 * Featured Collection Swiper initialization
 */
(() => {
  function initFeaturedCollectionSwiper() {
    const swiperContainers = document.querySelectorAll('.featured-collection__swiper[data-swiper-config]');

    swiperContainers.forEach((container) => {
      if (container.swiper) return; // Already initialized
      // Carruseles que se inicializan manualmente tras cargar datos (p. ej. vistos recientemente)
      if (container.closest('.recently-viewed-products')) return;

      const config = JSON.parse(container.dataset.swiperConfig || '{}');
      const sectionId = container.dataset.sectionId || '';

      const swiperOptions = {
        slidesPerView: config.mobileColumns || 1.2,
        spaceBetween: config.spaceBetween || 16,
        grabCursor: true,
        watchOverflow: true,
        navigation: {
          prevEl: `.featured-collection__nav-button--prev[data-section="${sectionId}"]`,
          nextEl: `.featured-collection__nav-button--next[data-section="${sectionId}"]`,
        },
        pagination: config.showPagination ? {
          el: `.featured-collection__pagination[data-section="${sectionId}"]`,
          clickable: true,
        } : false,
        autoplay: config.autoRotate && config.autoRotate !== 'disabled' ? {
          delay: parseInt(config.autoRotate, 10) * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        } : false,
        breakpoints: {
          750: {
            slidesPerView: config.tabletColumns || 3,
            spaceBetween: config.spaceBetween || 20,
          },
          990: {
            slidesPerView: config.desktopColumns || 4,
            spaceBetween: config.spaceBetween || 24,
          },
        },
      };

      new Swiper(container, swiperOptions);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollectionSwiper);
  } else {
    initFeaturedCollectionSwiper();
  }

  // Re-initialize on Shopify section events (Theme Editor)
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.featured-collection__swiper')) {
      initFeaturedCollectionSwiper();
    }
  });
})();

